"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.useLockButtonText = (adminRole, showOnOverlay, locked, disabled, parentIsLocked) => {
    return react_1.useMemo(() => {
        if (parentIsLocked) {
            return ['', ''];
        }
        if (disabled) {
            return locked
                ? ['Locked', 'Block was locked by admin']
                : ['Unlocked', 'Block was unlocked'];
        }
        if (showOnOverlay && adminRole) {
            return locked ? ['Unlock', 'Unlock block'] : ['Lock', 'Lock block'];
        }
        if (locked) {
            return ['Locked', 'Block was locked by admin'];
        }
        else {
            return ['', 'Lock block'];
        }
    }, [adminRole, showOnOverlay, locked]);
};
//# sourceMappingURL=useLockButtonText.js.map